<mg-table [collectionComponent]="this" matSort>

	<ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
        <td mat-cell *matCellDef="let row"> {{row.title}} </td>
    </ng-container>

	<ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Message </th>
        <td mat-cell *matCellDef="let row"> {{row.message}} </td>
    </ng-container>

	<ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date:'medium'}} </td>
    </ng-container>

	<ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let row"> {{row.type}} </td>
    </ng-container>

	<ng-container matColumnDef="person">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Person </th>
        <td mat-cell *matCellDef="let row"> {{row.person?.firstName}} </td>
    </ng-container>

	<ng-container matColumnDef="expiringDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expiring date </th>
        <td mat-cell *matCellDef="let row"> {{row.expiringDate | date:'medium'}} </td>
    </ng-container>

	<ng-container matColumnDef="customerSubscription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer subscription </th>
        <td mat-cell *matCellDef="let row"> {{row.customerSubscription?.name}} </td>
    </ng-container>

</mg-table>
